import { createTranslations } from '@npco/utils-translations'

export const cardsSettingsBreadcrumbsTranslations = createTranslations({
  breadcrumb: 'Cards',
  subBreadcrumb: 'Settings - Corporate Cards',
})
